// src/components/SupersetIFrame.jsx
import React, { useContext, useEffect, useState } from 'react';
import SUPERSET_CONFIG from '../config/superset';
import { AuthContext } from '../contexts/JWTContext';

const centerStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 10,
  fontSize: '16px',
};

export default function SupersetIFrame() {
  const { getSupersetCredentials } = useContext(AuthContext);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [supersetUrl, setSupersetUrl] = useState('');

  useEffect(() => {
    // Security check: Verify user is authenticated
    const token = window.localStorage.getItem('accessToken');
    const userRole = window.localStorage.getItem('userRole'); // Assuming you store user role

    if (!token) {
      // Redirect to login if no token
      window.location.href = '/login';
      return;
    }

    // Optional: Check if user has required role
    const allowedRoles = ['Global Admin', 'Group Admin', 'Internal', 'Manager', 'Supervisor'];
    if (userRole && !allowedRoles.includes(userRole)) {
      // Redirect to unauthorized page or show error
      window.location.href = '/unauthorized';
      return;
    }

    setIsAuthorized(true);
  }, []);

  useEffect(() => {
    if (!isAuthorized) return;

    const fetchSupersetCredentialsAndBuildUrl = async () => {
      try {
        setIsLoading(true);
        setHasError(false);

        const { username, password } = await getSupersetCredentials();
        console.log('[SupersetIFrame] Extracted username from context API:', username);

        // Decode Base64
        const decodedUsername = atob(username);
        const decodedPassword = atob(password);

        console.log('[SupersetIFrame] Decoded creds:', decodedUsername, decodedPassword);

        const builtUrl = SUPERSET_CONFIG.buildCredentialUrl(decodedUsername, decodedPassword);
        console.log('[SupersetIFrame] Built Superset URL:', builtUrl);

        setSupersetUrl(builtUrl);
        // Keep isLoading true until iframe onLoad fires

        
        // ---- OPEN ONCE GUARD (even under StrictMode) ----
        const openedKey = `superset-opened:${builtUrl}`;
        if (!sessionStorage.getItem(openedKey)) {
          // Opening in response to an async effect can be blocked by pop-up blockers
          // If that happens, fall back to rendering a button (see note below).
          window.open(builtUrl, '_blank', 'noopener,noreferrer');
          sessionStorage.setItem(openedKey, '1');
        }
      } catch (error) {
        console.error('[SupersetIFrame] Error in fetchSupersetCredentialsAndBuildUrl (context):', error);
        setHasError(true);
        setIsLoading(false);
      }
    };

    fetchSupersetCredentialsAndBuildUrl();
  }, [isAuthorized]);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  const handleIframeError = () => {
    setHasError(true);
    setIsLoading(false);
  };

  // Show loading while checking authorization
  if (!isAuthorized) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '16px'
      }}>
        Verifying access permissions...
      </div>
    );
  }

  // Superset URL will be set after fetching credentials

  return (
    <div style={{ width: '100%', height: '100vh', position: 'relative' }}>
      {hasError && (
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 10,
          color: 'red',
          fontSize: '16px'
        }}>
          Failed to load dashboard. Please try again.
        </div>
      )}
     
     {supersetUrl ? (
        <div style={centerStyle}>
          Superset dashboard has been opened in a new tab.
        </div>
      ) : (
        isLoading && (
          <div style={centerStyle}>
            Loading dashboard...
          </div>
        )
      )}
      
    </div>
  );
}
